import { render, staticRenderFns } from "./GerenciarPerfilEdicaoModal.vue?vue&type=template&id=6f5b2123&scoped=true"
import script from "./GerenciarPerfilEdicaoModal.vue?vue&type=script&lang=js"
export * from "./GerenciarPerfilEdicaoModal.vue?vue&type=script&lang=js"
import style0 from "./GerenciarPerfilEdicaoModal.vue?vue&type=style&index=0&id=6f5b2123&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b2123",
  null
  
)

export default component.exports